var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.multiline)?_c('v-textarea',_vm._g(_vm._b({attrs:{"outlined":"","validate-on-blur":""}},'v-textarea',_vm.$attrs,false),_vm.$listeners)):_c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","validate-on-blur":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }